export const errorMessages = {
  invalidLogin: 'Invalid login credentials',
  reportSolvedNoNewChatMessages:
    'Unable to add any new messages to the follow up chat, report was already marked as solved',
  institutionDoesNotExist: 'Institution does not exist',
  reportSourceDoesNotExist: 'Report source does not exist',

  // Investigation
  investigationClosed: 'Investigation is closed',
  investigationAlreadyClosed: 'Investigation is already closed',
  investigationNotReadyToClose:
    'Investigation cannot be closed: end date and closing reason are required',

  // Teams
  teamsAppNotInstalled: 'FaceUp App is not installed in Microsoft Teams',
  teamsFailedToFetchOrganization:
    'Failed to fetch organization information from Microsoft Graph API',
  teamsInvalidAuthenticationToken: 'Invalid authentication token for Microsoft Graph API',
  teamsUnableToFetchUserByEmail: 'Unable to fetch user by email from Microsoft Graph API',
  teamsUserNotFound: 'Microsoft Teams user not found',
}
